import { Head } from "@inertiajs/react";
import { ConnectNotificationBanner, ConnectPayouts } from "@stripe/react-connect-js";
import { t } from "@travily/i18n";
import {
  accountPayoutsConnectSessionPath,
  accountPayoutsDocumentsPath,
  accountPayoutsManagePath,
  accountPayoutsPath,
  accountPayoutsSalesPath,
} from "@travily/routes";
import { useStripeConnectSessionRefresher } from "@/hooks/use-stripe-connect-session-refresher";
import { PageFrame } from "@/layouts/page-frame";
import type { PayoutsTab } from "@/pages/account/payouts/components/PayoutsFrame";
import { PayoutsShowView } from "./show.view";

interface AccountPayoutsShowProps {
  client_secret: string;
  publishable_key: string;
}

const AccountPayoutsShowPage = ({ client_secret, publishable_key }: AccountPayoutsShowProps) => {
  const fetchRefreshedClientSecret = useStripeConnectSessionRefresher(accountPayoutsConnectSessionPath());
  const tabs = useTabs();

  return (
    <PageFrame mode="creator">
      <Head title={t("web.accounts.payouts.show.meta_title")} />
      <PayoutsShowView
        fetchRefreshedClientSecret={fetchRefreshedClientSecret}
        initialClientSecret={client_secret}
        publishableKey={publishable_key}
        tabs={tabs}
      >
        <ConnectNotificationBanner />
        <ConnectPayouts />
      </PayoutsShowView>
    </PageFrame>
  );
};

function useTabs(): PayoutsTab[] {
  return [
    { key: "overview", label: t("components.frames.payouts.tabs.overview"), href: accountPayoutsPath() },
    { key: "sales", label: t("components.frames.payouts.tabs.sales"), href: accountPayoutsSalesPath() },
    { key: "manage", label: t("components.frames.payouts.tabs.manage"), href: accountPayoutsManagePath() },
    { key: "documents", label: t("components.frames.payouts.tabs.documents"), href: accountPayoutsDocumentsPath() },
  ];
}

export default AccountPayoutsShowPage;
